module.exports = __webpack_public_path__ + "img/product_2.592c1b8.jpg";